import { useEffect, useRef } from "react";
import { useAnimationFrame } from "framer-motion";

export function Spin3D({ children, velocity, axis = "y", baseSpeed = 0.015, boost = 0.6, tilt = 16, className = "", style = {} }) {
  const ref = useRef(null);
  const state = useRef({ angle: Math.random() * 360, speed: baseSpeed });
  const reduced = useRef(false);

  useEffect(() => {
    reduced.current = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }, []);

  useAnimationFrame((_, delta) => {
    if (reduced.current || !ref.current) return;
    const v = velocity ? Math.min(Math.abs(velocity.get()), 6) : 0;
    const target = baseSpeed + v * boost * 0.05;
    state.current.speed += (target - state.current.speed) * 0.08;
    state.current.angle = (state.current.angle + state.current.speed * delta) % 360;
    const a = state.current.angle;
    ref.current.style.transform =
      axis === "x"
        ? `perspective(600px) rotateX(${a}deg)`
        : `perspective(800px) rotateX(${tilt}deg) rotateY(${a}deg)`;
  });

  return (
    <div className={className} style={{ ...style, transformStyle: "preserve-3d" }}>
      <div ref={ref} style={{ transformStyle: "preserve-3d", willChange: "transform", width: "fit-content" }}>
        {children}
      </div>
    </div>
  );
}
